import i18n from '../../../../../i18n'
import { SalutationCt } from '../../../../../model/enums/enums'

export const salutations = [
  {
    value: SalutationCt.NoSpecification,
    label: i18n.t<string>('core.no_specification'),
  },
  { value: SalutationCt.Ms, label: i18n.t<string>('salutation.ms') },
  { value: SalutationCt.Mr, label: i18n.t<string>('salutation.mr') },
  { value: SalutationCt.Diverse, label: i18n.t<string>('salutation.diverse') },
]